<template>
  <v-card
    outlined
    class="px-6"
  >
    <label class="subtitle-1 d-block pb-3 pt-2 mt-4 grey--text">Article Category</label>
    <v-select
      outlined
      v-model="categoryListener"
      label="Article Category"
      :items="article_categories"
    ></v-select>
  </v-card>
</template>

<script>
export default {
  data () {
    return {
      article_categories: [
        {
          text: 'Dimers content',
          value: 'dimers_content'
        },
        {
          text: 'API Ingested',
          value: 'api_ingested'
        }
      ]
    }
  },
  props: {
    articleCategory: {
      type: String,
      default: "dimers_content"
    },
  },

  computed: {
    categoryListener: {
      get () {
        return this.articleCategory
      },
      set (val) {
        this.$emit('update:articleCategory', val)
      }
    }
  }
}
</script>
